module.exports = __webpack_public_path__ + "static/media/layout8-img.c759d5a9.svg";